<template>
  <div class="keyword-links">
    <div class="header" :style="{ 'margin-left': !isDesktop && '10px' }">
      <label>URL language</label>
      <a-select
        v-model:value="language"
        style="width:170px;margin-left:10px;"
        @change="onLanguageChange"
      >
        <a-select-option
          v-for="item in langList"
          :key="item.key"
          :value="item.key"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <a-spin :spinning="spinning">
      <div class="content" v-if="keywordsList.length">
        <div class="link-item" v-for="item in keywordsList" :key="item.id">
          <div class="icon">
            <a :href="item.linkAddress">
              <LinkOutlined style="font-size:40px;color:#2486DF;" />
            </a>
          </div>
          <div class="link-info">
            <div class="link-name">{{ item.name }}</div>
            <div class="link-url">
              {{ item.linkAddress }}
            </div>
            <div class="link-oprator">
              <div
                class="link-view link-button"
                @click="handleView(item.linkAddress)"
              >
                View
              </div>
              <div class="link-add link-button" @click="handleAdd(item)">
                Add to Campaign
              </div>
            </div>
          </div>
          <div v-if="item.dueTime" class="link-deadline">
            Deadline {{ item.dueTime }}
          </div>
        </div>
      </div>
      <div v-else class="none-tips">
        Sorry, no keyword here, please try another language
      </div>
    </a-spin>
    <a-modal
      :visible="modalVisible"
      :maskClosable="false"
      title="Add to Campaign"
      okText="Confirm"
      @ok="handleConfirm"
      @cancel="handleCloseModal"
    >
      <div class="activity-modal">
        <a-select v-model:value="activityId" style="width:100%;">
          <a-select-option
            v-for="item in $store.state.link.allActivitiesList"
            :key="item.activityId"
            :value="item.activityId"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { LinkOutlined } from '@ant-design/icons-vue'

export default {
  name: 'KeywordLinks',
  components: { LinkOutlined },
  created() {
    this.onLanguageChange()
  },
  data() {
    return {
      language: 'en',
      langList: this.$store.state.base.languageList,
      modalVisible: false,
      activityId: undefined,
      selectedKeyword: undefined,
      keywordsList: [],
      spinning: false,
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  methods: {
    handleView(link) {
      window.open(link, 'target')
    },
    handleAdd(item) {
      this.selectedKeyword = item
      this.modalVisible = true
    },
    handleConfirm() {
      this.$store
        .dispatch('link/AddKeywordToActivity', {
          linkIdList: [
            {
              id: this.selectedKeyword.id,
              linkConfigurationType: this.selectedKeyword.linkConfigurationType,
            },
          ],
          activityId: this.activityId,
        })
        .then(() => {
          this.handleCloseModal()
          this.$message.success('Success')
          this.$store.dispatch('link/GetAllActivities')
        })
    },
    handleCloseModal() {
      this.modalVisible = false
      this.activityId = undefined
    },
    onLanguageChange() {
      this.spinning = !this.spinning
      this.$store
        .dispatch('link/GetKeywordsListByLanguage', {
          language: this.language,
        })
        .then((res) => {
          this.keywordsList = res
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.keyword-links {
  background-color: #fff;
  color: #333;
  padding: 20px;
  text-align: left;

  .header {
    label {
      font-size: 14px;
    }
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    padding-top: 0;
    margin-top: 20px;
    position: relative;

    .link-item {
      position: relative;
      width: 300px;
      height: 140px;
      box-shadow: 0px 0px 8px 0px rgba(8, 115, 211, 0.23);
      border-bottom: 4px #2486df solid;
      border-radius: 4px;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 6px 6px;

      .icon {
        display: inline-block;
        width: 58px;
        height: 58px;
        background-color: #eef2fd;
        padding: 9px;
      }

      .link-info {
        width: 193px;

        .link-name {
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          font-size: 14px;
        }

        .link-url {
          margin-top: 10px;
          height: 28px;
          font-size: 10px;
          font-weight: 400;
          color: #999999;
          line-height: 14px;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
        }

        .link-oprator {
          display: flex;
          justify-content: space-between;
          user-select: none;

          .link-button {
            border: 1px solid #2486df;
            border-radius: 2px;
            height: 24px;
            padding: 3px 10px;
            line-height: 18px;
            font-size: 12px;
            margin-top: 15px;
            transition: 0.5s;

            &:hover {
              cursor: pointer;
            }
          }

          .link-view {
            background: linear-gradient(to left, #00b0ff, #007dff) right;
            color: #fff;
            background-size: 200%;

            &:hover {
              background-position: left;
            }
          }

          .link-add {
            color: #2486df;

            &:hover {
              border-color: #00b0ff;
              color: #00b0ff;
            }
          }
        }
      }

      .link-deadline {
        position: absolute;
        right: 0;
        top: 0;
        padding: 3px 8px;
        background: linear-gradient(270deg, #4abbf1 0%, #2486df 100%);
        box-shadow: 0px 2px 4px 0px rgba(30, 161, 246, 0.5);
        font-size: 10px;
        color: #ffffff;
        line-height: 14px;
      }
    }

    .activity-modal {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .none-tips {
    text-align: center;
    margin-top: 20px;
    font-size: 18px;
  }
}

@media screen and (min-width: 320px) and (max-width: 374px) {
  .keyword-links {
    padding: 10px;
  }
  .keyword-links .content .link-item {
    width: 100%;
    padding: 10px;
    margin: 10px 4px;
  }
}
@media screen and (min-width: 375px) and (max-width: 414px) {
  .keyword-links .content .link-item {
    width: 100%;
  }
  .keyword-links .content .link-item .link-info {
    width: 210px;
  }
}
</style>
